import type { CellData as RootCellData } from '../types';
import type { getCellTemplate } from './utils';

export const kind = 'menu-cell' as const;

export interface MenuCellData extends RootCellData<typeof kind, string | null> {
  readonly allowedValues: readonly (
    | string
    | { value: string; label: string }
    | null
  )[];
  error: string | null;
}

export type MenuCell = ReturnType<typeof getCellTemplate>;
